module.exports = __webpack_public_path__ + "assets/f4af509e53eb7b5a52c828bda06d87e4.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-theme/app/fonts/Gotham-Medium.woff
 ** module id = 1738
 ** module chunks = 1
 **/